$(document).ready(function () {
    var slickInitialized = false; // Flag para verificar se o slick está inicializado
    var breakpoint = 768; // Defina o tamanho de breakpoint para mobile
    
function checkCarousel() {
    var windowWidth = $(window).width(); // Obtém a largura da janela
    var breakpoint = 768; // Define o ponto de quebra para dispositivos móveis
    var slickInitialized = false; // Rastreador para inicialização do Slick

    if (windowWidth < breakpoint) {
        if (!slickInitialized) {
            // Inicializa o Slick na seção services
            $('.services').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                arrows: false,
            });

            // Inicializa o Slick na seção midia
            $('.midia .itens').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                arrows: false,
            });

            // Inicializa o Slick na seção plans
            $('.plans').slick({
                slidesToShow: 1, // Mostra 1 slide por vez em telas menores
                slidesToScroll: 1, // Rola 1 slide por vez
                infinite: false, // Rolagem infinita ativada
                dots: true, // Adiciona os pontos de navegação
                arrows: false, // Adiciona setas de navegação
                responsive: [
                    {
                        breakpoint: 768, // Configurações para telas menores que 768px
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 1024, // Configurações para telas menores que 1024px
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 1200, // Configurações para telas maiores
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });

            slickInitialized = true; // Marca o Slick como inicializado
        }
    } else {
        if (slickInitialized) {
            // Remove o Slick para telas maiores
            $('.services').slick('unslick');
            $('.midia .itens').slick('unslick');
            $('.plans').slick('unslick');
            slickInitialized = false;
        }
    }
}

// Monitora redimensionamento da janela
$(window).on('resize', checkCarousel);
// Chama a função ao carregar a página
$(document).ready(checkCarousel);


    // Verifica o tamanho da janela ao carregar a página
    checkCarousel();

    // Verifica o tamanho da janela ao redimensionar
    $(window).on('resize', function() {
        checkCarousel();
    });

    // Slider para galeria (se houver)
    $(".galeria").slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                }
            }
        ]
    });

    // Slider para empresas
    $(".expEmpresas").slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });

    $(".opcionais-container").slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

});

$('.autoplay').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  infinite: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 768, 
      settings: {
        arrows: true,
        slidesToShow: 1, 
        slidesToScroll: 1,
       
      }
    }
  ]
});



function labnolIframe(div) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'https://www.youtube.com/embed/' + div.dataset.id + '?autoplay=1');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '1');
    iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
    div.parentNode.replaceChild(iframe, div);
  }

  function initYouTubeVideos() {
    var playerElements = document.querySelectorAll('.youtube-player');
    for (var n = 0; n < playerElements.length; n++) {
      var videoId = playerElements[n].dataset.id;
      var div = document.createElement('div');
      div.setAttribute('data-id', videoId);
      var thumbNode = document.createElement('img');
      thumbNode.src = '//i.ytimg.com/vi/ID/hqdefault.jpg?sqp=-oaymwE2CNACELwBSFXyq4qpAygIARUAAIhCGAFwAcABBvABAfgB_g6AArgIigIMCAAQARhlIGIoUjAP&rs=AOn4CLDrEHzvuUqAtodelZqNhMjuTMifEQ'.replace('ID', videoId);
      div.appendChild(thumbNode);
      var playButton = document.createElement('div');
      playButton.setAttribute('class', 'play');
      div.appendChild(playButton);
      div.onclick = function () {
        labnolIframe(this);
      };
      playerElements[n].appendChild(div);
    }
  }

  document.addEventListener('DOMContentLoaded', initYouTubeVideos);